/**
 * RangeSlider — legacy API over Astryx's Slider (see DESIGN.md, Sliders).
 *
 * The live value belongs in the caller's label row (right-aligned), never in
 * a readout on the track — so the Slider's own label and value display stay
 * hidden. No tier markers along the track; endpoint hints are the caller's.
 */
import { Slider } from "@astryxdesign/core/Slider";

interface RangeSliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  "aria-label": string;
  disabled?: boolean;
}

export function RangeSlider({
  min,
  max,
  step = 1,
  value,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
}: RangeSliderProps): React.JSX.Element {
  return (
    <Slider
      label={ariaLabel}
      isLabelHidden
      value={value}
      onChange={(next: number) => onChange(next)}
      min={min}
      max={max}
      step={step}
      valueDisplay="none"
      isDisabled={disabled}
    />
  );
}
